<p-toast></p-toast>

<!-- ================= SUCCESS ================= -->
<ng-container *ngIf="isSuccess === true">
  <div class="da-header-section">
    <h1>Payment Successful</h1>
    <div class="subtext">Your payment has been received. Review the details below and continue.</div>
  </div>

  <div class="da-main-layout">
    <div class="da-card payment-card">

      <!-- Loading transaction -->
      <div class="payment-loading" *ngIf="loadingTransaction">
        <i class="pi pi-spin pi-spinner"></i>
        <p>Loading transaction details...</p>
      </div>

      <!-- Receipt (also used for the PDF download) -->
      <div id="receiptPdfArea" class="receipt" *ngIf="!loadingTransaction">
        <div class="receipt-header">
          <div class="success-icon"><i class="pi pi-check-circle"></i></div>
          <h2>Payment Receipt</h2>
        </div>

        <div class="receipt-meta">
          <div class="meta-item">
            <span class="label">Transaction ID</span>
            <span class="value">{{ transaction?.transactionId || txnId }}</span>
          </div>
          <div class="meta-item" *ngIf="transaction?.paymentDate">
            <span class="label">Payment Date</span>
            <span class="value">{{ formatDate(transaction?.paymentDate) }}</span>
          </div>
        </div>

        <div class="divider"></div>

        <div class="receipt-section" *ngIf="transaction?.customerDetails">
          <h3 class="section-title"><i class="pi pi-user"></i> Customer Details</h3>
          <div class="detail-row"><span class="d-label">Name</span><span class="d-value">{{ transaction?.customerDetails?.name }}</span></div>
          <div class="detail-row"><span class="d-label">Email</span><span class="d-value">{{ transaction?.customerDetails?.email }}</span></div>
          <div class="detail-row"><span class="d-label">Phone</span><span class="d-value">{{ transaction?.customerDetails?.phone }}</span></div>
        </div>

        <div class="divider" *ngIf="transaction?.packageDetails"></div>

        <div class="receipt-section" *ngIf="transaction?.packageDetails">
          <h3 class="section-title"><i class="pi pi-box"></i> Package</h3>
          <div class="package-name">{{ transaction?.packageDetails?.packageName }}</div>
          <ul class="services-list" *ngIf="transaction?.packageDetails?.servicesIncluded?.length">
            <li *ngFor="let service of transaction?.packageDetails?.servicesIncluded">
              <i class="pi pi-check"></i> {{ service }}
            </li>
          </ul>
        </div>

        <div class="divider" *ngIf="transaction?.paymentSummary"></div>

        <div class="receipt-section" *ngIf="transaction?.paymentSummary">
          <h3 class="section-title"><i class="pi pi-money-bill"></i> Payment Summary</h3>
          <div class="summary-row">
            <span>Package Amount</span>
            <span>₹{{ transaction?.paymentSummary?.packageAmount | number:'1.2-2' }}</span>
          </div>
          <div class="summary-row total">
            <span>Total Paid</span>
            <span>₹{{ transaction?.paymentSummary?.totalPaid | number:'1.2-2' }}</span>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="payment-actions" *ngIf="!loadingTransaction">
        <button type="button" class="btn btn-secondary" (click)="downloadReceipt()">
          <i class="pi pi-download"></i> Download Receipt
        </button>
        <button type="button" class="btn btn-primary" (click)="continueToConfirmation()">
          Continue <i class="pi pi-chevron-right"></i>
        </button>
      </div>

    </div>
  </div>
</ng-container>

<!-- ================= FAILURE ================= -->
<ng-container *ngIf="isSuccess === false">
  <div class="da-header-section">
    <h1>Payment Failed</h1>
    <div class="subtext">We couldn't process your payment. You can try again below.</div>
  </div>

  <div class="da-main-layout">
    <div class="da-card payment-card failure-card">
      <div class="failure-icon"><i class="pi pi-times-circle"></i></div>
      <h3>Your payment was not successful</h3>
      <p class="failure-reason" *ngIf="failureReason">{{ failureReason }}</p>
      <p class="failure-reason" *ngIf="!failureReason">The payment could not be completed. Please try again.</p>

      <button type="button" class="btn btn-primary retry-btn" (click)="retryPayment()" [disabled]="retrying">
        <i class="pi" [ngClass]="retrying ? 'pi-spin pi-spinner' : 'pi-refresh'"></i>
        {{ retrying ? 'Redirecting...' : 'Retry Payment' }}
      </button>
    </div>
  </div>
</ng-container>

<!-- ================= NO RESULT (fallback) ================= -->
<ng-container *ngIf="isSuccess === null">
  <div class="da-header-section">
    <h1>Payment</h1>
    <div class="subtext">Complete your payment to lock in your applications.</div>
  </div>
  <div class="da-main-layout">
    <div class="da-card payment-card">
      <div class="payment-loading">
        <i class="pi pi-spin pi-spinner"></i>
        <p>Awaiting payment result...</p>
      </div>
    </div>
  </div>
</ng-container>
